The name of the querying partner.
